import { Action } from '@ngrx/store';
import {
  Discussion,
  DiscussionMessage,
  DiscussionMessageToSend,
  Discussions,
  MessagesContact
} from './messages.models';

export enum MessagesActionsTypes {
  LOAD_DISCUSSIONS = '[MessagesAction] Load discussions',
  LOAD_DISCUSSIONS_FAILED = '[MessagesAction] Load discussions failed',
  LOAD_DISCUSSIONS_SUCCESS = '[MessagesAction] Load discussions success',
  LOAD_SELECTED_DISCUSSION = '[MessagesAction] Load selected discussion',
  LOAD_SELECTED_DISCUSSION_FAILED = '[MessagesAction] Load selected discussion failed',
  LOAD_SELECTED_DISCUSSION_SUCCESS = '[MessagesAction] Load selected discussion success',
  SEND_MESSAGE = '[MessagesAction] Send message',
  SEND_MESSAGE_FAILED = '[MessagesAction] Send message failed',
  SEND_MESSAGE_SUCCESS = '[MessagesAction] Send message success',
  LOAD_CONTACTS = '[MessagesAction] Load contacts',
  LOAD_CONTACTS_FAILED = '[MessagesAction] Load contacts failed',
  LOAD_CONTACTS_SUCCESS = '[MessagesAction] Load contacts success',
  SELECT_CONTACT = '[MessageAction] Select contact',
  SELECT_DISCUSSION = '[MessageAction] Select discussion',
  CREATE_DISCUSSION_FAILED = '[MessageAction] Create discussion failed',
  DOWNLOAD_AND_OPEN_FILE = '[MessageAction] Download and open file',
  DOWNLOAD_AND_OPEN_FILE_SUCCESS = '[MessageAction] Download and open file success',
  DOWNLOAD_AND_OPEN_FILE_FAILED = '[MessageAction] Download and open file failed'
}

export class MessagesActionLoadDiscussions implements Action {
  readonly type = MessagesActionsTypes.LOAD_DISCUSSIONS;
}

export class MessagesActionLoadDiscussionsFailed implements Action {
  readonly type = MessagesActionsTypes.LOAD_DISCUSSIONS_FAILED;
}

export class MessagesActionLoadDiscussionsSuccess implements Action {
  readonly type = MessagesActionsTypes.LOAD_DISCUSSIONS_SUCCESS;

  constructor(public payload: Discussions) {}
}

export class MessagesActionLoadSelectedDiscussion implements Action {
  readonly type = MessagesActionsTypes.LOAD_SELECTED_DISCUSSION;
}

export class MessagesActionLoadSelectedDiscussionFailed implements Action {
  readonly type = MessagesActionsTypes.LOAD_SELECTED_DISCUSSION_FAILED;
}

export class MessagesActionLoadSelectedDiscussionSuccess implements Action {
  readonly type = MessagesActionsTypes.LOAD_SELECTED_DISCUSSION_SUCCESS;

  constructor(public payload: Discussion) {}
}

export class MessagesActionSendMessage implements Action {
  readonly type = MessagesActionsTypes.SEND_MESSAGE;

  constructor(public payload: DiscussionMessageToSend) {}
}

export class MessagesActionSendMessageFailed implements Action {
  readonly type = MessagesActionsTypes.SEND_MESSAGE_FAILED;
}

export class MessagesActionSendMessageSuccess implements Action {
  readonly type = MessagesActionsTypes.SEND_MESSAGE_SUCCESS;

  constructor(public payload: DiscussionMessage) {}
}

export class MessagesActionLoadContacts implements Action {
  readonly type = MessagesActionsTypes.LOAD_CONTACTS;
}

export class MessagesActionLoadContactsFailed implements Action {
  readonly type = MessagesActionsTypes.LOAD_CONTACTS_FAILED;
}

export class MessagesActionLoadContactsSuccess implements Action {
  readonly type = MessagesActionsTypes.LOAD_CONTACTS_SUCCESS;

  constructor(public payload: Array<MessagesContact>) {}
}

export class MessagesActionSelectContact implements Action {
  readonly type = MessagesActionsTypes.SELECT_CONTACT;

  constructor(public payload: MessagesContact) {}
}

export class MessagesActionSelectDiscussion implements Action {
  readonly type = MessagesActionsTypes.SELECT_DISCUSSION;

  constructor(public payload: string) {}
}

export class MessagesActionCreateDiscussionFailed implements Action {
  readonly type = MessagesActionsTypes.CREATE_DISCUSSION_FAILED;
}

export class MessagesActionDownloadAndOpenFile implements Action {
  readonly type = MessagesActionsTypes.DOWNLOAD_AND_OPEN_FILE;

  constructor(public payload: string) {}
}

export class MessagesActionDownloadAndOpenFileFailed implements Action {
  readonly type = MessagesActionsTypes.DOWNLOAD_AND_OPEN_FILE_FAILED;
}

export class MessagesActionDownloadAndOpenFileSuccess implements Action {
  readonly type = MessagesActionsTypes.DOWNLOAD_AND_OPEN_FILE_SUCCESS;
}

export type MessagesActions =
  | MessagesActionLoadDiscussions
  | MessagesActionLoadDiscussionsFailed
  | MessagesActionLoadDiscussionsSuccess
  | MessagesActionLoadSelectedDiscussion
  | MessagesActionLoadSelectedDiscussionFailed
  | MessagesActionLoadSelectedDiscussionSuccess
  | MessagesActionSendMessage
  | MessagesActionSendMessageFailed
  | MessagesActionSendMessageSuccess
  | MessagesActionLoadContacts
  | MessagesActionLoadContactsFailed
  | MessagesActionLoadContactsSuccess
  | MessagesActionSelectContact
  | MessagesActionSelectDiscussion
  | MessagesActionCreateDiscussionFailed
  | MessagesActionDownloadAndOpenFile
  | MessagesActionDownloadAndOpenFileSuccess
  | MessagesActionDownloadAndOpenFileFailed;
